import { Link } from "react-router-dom";

export default function ConsentCheckbox({ checked, onChange, testid = "consent-checkbox", text }) {
    return (
        <label className="flex items-start gap-3 text-xs text-aimploy-muted leading-relaxed cursor-pointer">
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                required
                data-testid={testid}
                className="mt-0.5 h-4 w-4 rounded border-aimploy-navy/30 text-aimploy-violet focus:ring-aimploy-violet flex-shrink-0"
            />
            <span>
                {text || (
                    <>
                        Ich willige ein, dass meine Angaben zur Bearbeitung meiner Anfrage gemäß{" "}
                        <Link to="/datenschutz" target="_blank" className="text-aimploy-violet underline hover:no-underline">
                            Datenschutzerklärung
                        </Link>
                        {" "}verarbeitet werden. Widerruf jederzeit per E-Mail an kontakt@aimploy.de möglich.
                    </>
                )}
            </span>
        </label>
    );
}
